import { createFeatureSelector, createSelector } from '@ngrx/store';

import { JamState } from '@app/models/jam.model';

export const jamStoreName = 'jam';
export const selectJamState = createFeatureSelector<JamState>(jamStoreName);
export const selectJamMetadata = createSelector(selectJamState,(state) => state?.metadata || {});